import mapboxgl from "mapbox-gl";

export default class MapPlugin {

  constructor(name, map) {
    this.name = name;
    this._ops = map;
    this._map = map._map;
    this._mounted = false;
    this.t = this._ops.t;
    this.theme = this._ops.theme;
    this._popups = new Map();
    this._dialogs = new Map();
    this._events = [];
    this.settings = {};
    this.defaultSettings = {};
  }


  setSettings(settings) {
    this.settings = { ...this.defaultSettings, ...settings };
  }

  resetSettings() {
    this.updateSettings(this.defaultSettings);
    this.settings = this.defaultSettings;
  }

  addPopup(name, layer, callback, options = { contentInCallback: false, showInDialog: false, title: "", showInTooltip: false }) {
    const { contentInCallback, showInDialog, showInTooltip, title } = options;

    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false
    });

    const onMouseEnter = (e) => {
      this._map.getCanvas().style.cursor = "pointer";
      const properties = e.features[0].properties;

      if (!properties || showInDialog && !showInTooltip) return;

      this.clearPopupsFromAllPlugins();

      const coordinates = e.features[0].geometry.coordinates.slice();

      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      if (contentInCallback) {
        callback(e, properties, content => {
          popup.setLngLat(coordinates).setHTML(content).setOffset(26).addTo(this._map);
          this._ops._hasPopups = true;
        });

      } else {
        const content = callback(e, properties);
        popup.setLngLat(coordinates).setHTML(content).setOffset(26).addTo(this._map);
        this._ops._hasPopups = true;
      }

    };

    const onMouseLeave = () => {
      this._map.getCanvas().style.cursor = "";
      this.clearPopupsFromAllPlugins();
    };

    this._popups.set(name, {
      onMouseEnter,
      onMouseLeave,
      component: popup,
      layer
    });

    if (showInDialog) {

      this.on("click", layer, (e) => {
        this.clearPopupsFromAllPlugins();
        const properties = e.features[0].properties;

        if (contentInCallback) {
          callback(e, properties, content => {
            this.emitToProvider("popupDialog", { content, properties, title });
          });
  
        } else {
          const content = callback(e, properties);          
          this.emitToProvider("popupDialog", { content, properties, title });
        }
      });
    }

  }

  on(name, layer, callback) {
    this._events.push({ name, layer, callback });
  }

  clearPopupsFromAllPlugins() {
    return this._ops.clearPopups();
  }

  clearPopups() {
    [...this._popups.values()].forEach(p => p.component?.remove());
  }

  async getAccessToken() {
    return await this._ops.getAccessToken();
  }

  get station() {
    return this._ops.station;
  }

  get mobile() {
    return this._ops.mobile;
  }

  get vehicles() {
    return this._ops.vehicles;
  }

  mount() {
    if (!this._mounted) {
      this._mounted = true;

      [...this._popups.values()].forEach(popup => {
        this._map.on("mouseenter", popup.layer, popup.onMouseEnter);
        this._map.on("mouseleave", popup.layer, popup.onMouseLeave);
      });

      this._events.forEach(ev => this._map.on(ev.name, ev.layer, ev.callback));

      this.onMount();
    }
  }

  emitToProvider(name, data) {
    this._ops.emit(name, data);
  }

  unMount() {
    if (this._mounted) {
      this._mounted = false;
      
      [...this._popups.values()].forEach(popup => {
        this._map.off("mouseenter", popup.layer, popup.onMouseEnter);
        this._map.off("mouseleave", popup.layer, popup.onMouseLeave);
      });

      this._events.forEach(ev => this._map.off(ev.name, ev.layer, ev.callback));

      this.onUnMount();
    }
  }

  onMount() { }

  onUnMount() { }

  get destroyed() {
    return this._ops._destroyed;
  }

  get styleId() {
    return this._ops.styleId;
  }

  addImage(name) {
    this._ops.addImage(name);
  }

  addModel(name, src) {
    this._ops.addModel(name, src);
  }

  updateDispatchData(filteredTasks, completedTasks) {
    if (this._mounted) {
      this.onUpdateDispatchData(filteredTasks, completedTasks);
    }
  }

  onUpdateDispatchData(filteredTasks, completedTasks) { }

  updateVehicleData(vehicles) {
    if (this._mounted) {
      this.onUpdateVehicleData(vehicles);
    }
  }

  onUpdateVehicleData(vehicles) { }


  updateFleetIntegrations(fleetIntegrations) {
    if (this._mounted) {
      this.onUpdateFleetIntegrations(fleetIntegrations);
    }
  }

  onUpdateFleetIntegrations(fleetIntegrations) { }


  updateSettings(settings = {}) {
    if (this._mounted) {
      this.settings = { ...this.settings, ...settings };
      this.onUpdateSettings(this.settings, settings);
    }
  }

  onUpdateSettings(settings) { }

}